import * as Style from './styles';

export const ListItemButton = ({children, ...rest}) => {
    return(
        <Style.Li {...rest}>
            {children}
        </Style.Li>    
    )
}